import { Link, useNavigate } from 'react-router-dom';
import React, { useState, useEffect, useRef, createContext } from 'react';
import { getAuth, signOut } from 'firebase/auth';
import { getFirestore, doc, getDocs, onSnapshot, collection } from 'firebase/firestore';
import appFirebase from '../../Firebase/Firebase';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faMoneyBill, faWallet, faCalendarAlt, faComments, faSignOutAlt, faSitemap, faUserGroup, faFilter } from '@fortawesome/free-solid-svg-icons';
import logoClaro from '../../img/logoDark.png';
import { Menu, X } from 'lucide-react';
import './NavBarMobileCoworking.css';
import logo from '../../images/Logo.png'; // Asegúrate de importar la imagen
import { useTipoEspacio } from '../context/FiltroTipoEspacioContext';
import coworkingB from '../../img/coworkingB.png';
import serviciosB from '../../img/servicioB.png';
import academiaB from '../../img/academiaB.png';
import coworkingN from '../../img/coworkingN.png';
import serviciosN from '../../img/servicioN.png';
import academiaN from '../../img/academiaN.png';
const avatarsMap = {
    userAvatar1: require('../../images/1.png'),
    userAvatar2: require('../../images/2.png'),
    userAvatar3: require('../../images/3.png'),
    userAvatar4: require('../../images/4.png'),
    userAvatar5: require('../../images/5.png'),
    userAvatar6: require('../../images/6.png'),
    userAvatar7: require('../../images/7.png'),
    userAvatar8: require('../../images/8.png'),
};

const db = getFirestore(appFirebase);
const auth = getAuth();
function NavBarMobileCoworking({ isDarkMode, toggleDarkMode }) {
    const { setTipoSeleccionado } = useTipoEspacio(); // Usamos el contexto para actualizar el estado
    let lastScrollY = window.scrollY;

    const [filterMenuOpen, setFilterMenuOpen] = useState(false);  // Estado para abrir/cerrar el submenú de filtros
    const [avatarName, setAvatarName] = useState('userAvatar1');
    const [usuario, setUsuario] = useState(null);
    const [userName, setUserName] = useState('');
    const [role, setRole] = useState('');
    const [userMenuOpen, setUserMenuOpen] = useState(false);
    const userMenuRef = useRef(null);
    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const [tipoEspacios, setTipoEspacios] = useState([]);
    const handleTipoEspacioSelect = (idTipoEspacio) => {
        setTipoSeleccionado(idTipoEspacio); // Actualiza el tipo seleccionado globalmente
        setFilterMenuOpen(false); // Cerrar el filtro al seleccionar tipo
    };
    const toggleFilterMenu = () => setFilterMenuOpen(!filterMenuOpen);
    useEffect(() => {
        const fetchTipoEspacios = async () => {
            const querySnapshot = await getDocs(collection(db, "tipoespacio"));
            const espacios = querySnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
            setTipoEspacios(espacios);
        };

        fetchTipoEspacios();
    }, []);
   
    
    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
            if (user) {
                setUsuario(user);
                const userDocRef = doc(db, 'usuarios', user.uid);
                const unsubscribeSnapshot = onSnapshot(userDocRef, (doc) => {
                    if (doc.exists()) {
                        const data = doc.data();
                        setRole(data.role);
                        setUserName(data.name || '');
                        setAvatarName(data.avatar || 'userAvatar1');
                    } else {
                        console.log('No such document!');
                    }
                });
                return () => unsubscribeSnapshot();
            } else {
                setUsuario(null);
                setRole('');
                setUserName('');
                setAvatarName('userAvatar1');
            }
        });
        return () => unsubscribe();
    }, [auth, db]);
    const toggleUserMenu = () => setUserMenuOpen(!userMenuOpen);
    const getAvatarSrc = (avatarName) => avatarsMap[avatarName] || avatarsMap.userAvatar1;
    const handleMenuLinkClick = () => {
        setMenuOpen(false);
    };
    const handleButtonClick = () => {
        handleMenuLinkClick();
        setIsModalOpen(true);  // Abre el modal al hacer clic en el botón
    };
    const handleSignOut = () => {
        signOut(auth);
        setUserMenuOpen(false);
    };
    const handleProfileClick = () => {
        setUserMenuOpen(false);
        navigate('/myprofile');
    };
    const [scrollDirection, setScrollDirection] = useState(null);

    useEffect(() => {
        const handleScrollDirection = () => {
            if (window.scrollY) {
                setUserMenuOpen(false);
            }
            if (window.scrollY > lastScrollY) {
                setScrollDirection('down');
            } else {
                setScrollDirection('up');
            }
            lastScrollY = window.scrollY;
        };
        window.addEventListener('scroll', handleScrollDirection);
        return () => window.removeEventListener('scroll', handleScrollDirection);
    }, []);
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setScrolled(true); // Se hace scroll más de 50px
            } else {
                setScrolled(false); // No se hace scroll
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);
    const toggleMenu = () => setMenuOpen(!menuOpen);
    return (
        <nav className={`navbar_coworking ${scrolled ? 'scrolled' : ''} ${menuOpen ? 'menu-open' : ''}`}>
            <div className="navbar_mobile_coworking">
                <ul className="navbar__bottom-menu">
                    <li>
                        <Link to="/coworking">
                            <img
                                src={isDarkMode ? coworkingN : coworkingB}
                                className={`iconos-navbar4 ${scrolled ? 'hide-on-scroll' : ''}`}
                            />
                            <span>Coworking</span>
                        </Link>
                    </li>
                    <li>
                        <Link to="/servicios">
                            <img
                                src={isDarkMode ? serviciosN : serviciosB}
                                className={`iconos-navbar4 ${scrolled ? 'hide-on-scroll' : ''}`}
                            />
                            <span>Servicios</span>
                        </Link>
                    </li>
                    <li>
                        <Link to="https://edu-laofi-academy.odoo.com/home-academy" target="_blank">
                            <img
                                src={isDarkMode ? academiaN : academiaB}
                                className={`iconos-navbar4 ${scrolled ? 'hide-on-scroll' : ''}`}
                            />
                            <span>Academia</span>
                        </Link>
                    </li>

                    {/* Este es el nuevo contenedor para el ícono de filtro */}
                    <li className="filter-icon-container">
                        <button onClick={toggleFilterMenu} className="filter-button">
                            <FontAwesomeIcon icon={faFilter} />
                        </button>
                    </li>
                </ul>

                {/* Submenú de filtros */}
                {filterMenuOpen && (
                    <div className="filter-submenu">
                        <h3>Filtrar por:</h3>
                        <div className="tipoespacios-menu">
                            {tipoEspacios.map((espacio) => (
                                <div
                                    key={espacio.id}
                                    className="tipoespacio-item"
                                    onClick={() => handleTipoEspacioSelect(espacio.id)}
                                >
                                    <span>{espacio.TipoEspacio}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                )}


                <div className={`navbar__bottom-fixed ${scrollDirection === 'down' ? 'hide' : 'show'}`}>
                    <div className="bottom-fixed-content">
                        <Link to="/">
                            <img src={isDarkMode ? logoClaro : logo} alt="logo" className="logo-img" />
                        </Link>

                        <label className="switch">
                            <input type="checkbox" onChange={toggleDarkMode} checked={isDarkMode} />
                            <span className="slider"><span className="thumb-icon">{isDarkMode ? '🌙' : '🌞'}</span></span>
                        </label>

                        {/*!usuario ? <Link to="/login" className='modo-anfitrion'>Conviértete en Anfitrión</Link> : <Link to="/#" className='modo-anfitrion'>Modo Anfitrión</Link>*/}
                        <div className="cuenta-icon">

                            {!usuario ? (
                                <Link to="/login"><p className="modo-anfitrion">Inicia sesión</p></Link>
                            ) : (
                                <div className="navbar__account-button" onClick={toggleUserMenu} ref={userMenuRef}>
                                    <img src={getAvatarSrc(avatarName)} alt="Avatar" className="navbar__avatar" />Mi Cuenta
                                    {userMenuOpen && (
                                        <ul className="navbar__submenu">
                                            <span className="navbar__username">{userName}</span><br />
                                            <small className="user-email">{usuario.email}</small>
                                            <li onClick={handleProfileClick}><FontAwesomeIcon icon={faUser} /> Perfil</li>
                                            {role === 'admin' && (
                                                <ul>
                                                    <li>
                                                        <Link to="/create-coin-package" onClick={handleMenuLinkClick} >
                                                            <p className="modo-anfitrion"> <FontAwesomeIcon icon={faMoneyBill} /> Crear Paquete de Monedas</p>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/verficarCoinsComprados" onClick={handleMenuLinkClick} >
                                                            <p className="modo-anfitrion"> <FontAwesomeIcon icon={faSitemap} /> Verificar Compras</p>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/Reservas_Admin" onClick={handleMenuLinkClick} >
                                                            <p className="modo-anfitrion"><FontAwesomeIcon icon={faCalendarAlt} /> Reservas</p>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/space" onClick={handleMenuLinkClick} >
                                                            <p className="modo-anfitrion"> <FontAwesomeIcon icon={faSitemap} /> Pon tu espacio</p>
                                                        </Link>
                                                    </li>

                                                    <li>
                                                        <Link to="/users" onClick={handleMenuLinkClick} >
                                                            <p className="modo-anfitrion"><FontAwesomeIcon icon={faUserGroup} /> Usuarios</p>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/Busquedas" onClick={handleMenuLinkClick} >
                                                            <p className="modo-anfitrion"><FontAwesomeIcon icon={faCalendarAlt} />Busquedas</p>
                                                        </Link>
                                                    </li>
                                                </ul>
                                            )}
                                            {role === 'user' && (
                                                <>
                                                    <li>
                                                        <Link to="/wallet" onClick={handleMenuLinkClick} >
                                                            <p className="modo-anfitrion"><FontAwesomeIcon icon={faWallet} /> Wallet</p>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/reservasRealizadas" onClick={handleMenuLinkClick} >
                                                            <p className="modo-anfitrion"> <FontAwesomeIcon icon={faCalendarAlt} /> Mis Reservas</p>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/coin-purchase" onClick={handleMenuLinkClick} >
                                                            <p className="modo-anfitrion"><FontAwesomeIcon icon={faComments} /> Comentarios</p>
                                                        </Link>
                                                    </li>
                                                </>
                                            )}
                                            {
                                                role === 'prov' && (
                                                    <>
                                                        <li>
                                                            <Link to="/wallet" onClick={handleMenuLinkClick} >
                                                                <p className="modo-anfitrion"><FontAwesomeIcon icon={faWallet} /> Wallet</p>
                                                            </Link>
                                                        </li>
                                                        <li>
                                                            <Link to="/Reservas_Admin" onClick={handleMenuLinkClick} >
                                                                <p className="modo-anfitrion"><FontAwesomeIcon icon={faCalendarAlt} /> Reservas</p>
                                                            </Link>
                                                        </li>
                                                        <li>
                                                            <Link to="/space" onClick={handleMenuLinkClick} >
                                                                <p className="modo-anfitrion"><FontAwesomeIcon icon={faSitemap} />Pon tu espacio</p>
                                                            </Link>
                                                        </li>
                                                        <li>
                                                            <Link to="/proveedor/misMarcas" onClick={handleMenuLinkClick} >
                                                                <p className="modo-anfitrion"><FontAwesomeIcon icon={faSitemap} /> Administra tu marca</p>
                                                            </Link>
                                                        </li>
                                                        <Link to="/coin-purchase" onClick={handleMenuLinkClick}>
                                                            <p className="modo-anfitrion"><FontAwesomeIcon icon={faComments} /> Comentarios</p>
                                                        </Link>

                                                        <li>
                                                            <Link to="/users" onClick={handleMenuLinkClick} >
                                                                <p className="modo-anfitrion"> <FontAwesomeIcon icon={faUserGroup} /> Clientes</p>
                                                            </Link>
                                                        </li>
                                                    </>
                                                )
                                            }                                            <li onClick={handleSignOut}><FontAwesomeIcon icon={faSignOutAlt} /> Cerrar sesión</li>
                                        </ul>
                                    )}
                                </div>
                            )}

                        </div>
                    </div>
                </div>

            </div>

        </nav>
    );
}
export default NavBarMobileCoworking;